module.exports = "/_next/static/images/29898d41feb2c97618be30ee3aa7aad6-fees-right-lg.jpg";